import {
  PreloadedQueryRef,
  useQueryRefHandlers,
  useReadQuery,
} from '@apollo/client';
import {
  StreamsAllQueryQuery,
  StreamsCreatedQueryQuery,
  StreamsFollowingQueryQuery,
} from '@/__generated__/graphql.ts';
import { EmptyStreamsFeed } from '@/components/stream-list/empty-streams-feed.tsx';
import { StreamList } from '@/components/stream-list/stream-list.tsx';

export const StreamResults = ({
  queryRef,
  skeletonItemCount,
}: {
  queryRef: PreloadedQueryRef<
    StreamsAllQueryQuery | StreamsCreatedQueryQuery | StreamsFollowingQueryQuery
  >;
  skeletonItemCount?: number;
}) => {
  const { fetchMore } = useQueryRefHandlers(queryRef);

  const { data } = useReadQuery(queryRef);

  const streams =
    'streamsAll' in data
      ? data.streamsAll
      : 'streamsCreated' in data
        ? data.streamsCreated
        : data.streamsFollowing;

  return (
    <StreamList
      streams={streams.items}
      skeletonItemCount={skeletonItemCount}
      hasNext={!!streams.nextToken}
      loadMore={() => {
        fetchMore({
          variables: {
            nextToken: streams.nextToken,
          },
        });
      }}
      emptyState={<EmptyStreamsFeed />}
    />
  );
};
